// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## PlanDefinition Get
/**
 *
 * @param {{params: object, query: { date: string, page: number, limit: number  }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.PlanDefinition.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## PlanDefinition Create
/**
 *
 * @param {{ "startDate": string, "edDate": string, "expiredDay": number }} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.PlanDefinition.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## PlanDefinition Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.PlanDefinition.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## PlanDefinition Update
/**
 *
 * @param {{"startDate": string,"endDate": string,"expiredDay": number, isActive: boolean}} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(
    Endpoints.PlanDefinition.Update(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## PlanDefinition Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.PlanDefinition.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
};
